import { render, staticRenderFns } from "./JSelectDepartModalFood.vue?vue&type=template&id=6d967106&scoped=true&"
import script from "./JSelectDepartModalFood.vue?vue&type=script&lang=js&"
export * from "./JSelectDepartModalFood.vue?vue&type=script&lang=js&"
import style0 from "./JSelectDepartModalFood.vue?vue&type=style&index=0&id=6d967106&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d967106",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d967106')) {
      api.createRecord('6d967106', component.options)
    } else {
      api.reload('6d967106', component.options)
    }
    module.hot.accept("./JSelectDepartModalFood.vue?vue&type=template&id=6d967106&scoped=true&", function () {
      api.rerender('6d967106', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecgbiz/modal/JSelectDepartModalFood.vue"
export default component.exports